(function(angular) {
    'use strict';
    
    angular.module('app')
    /**
     * 
     */
    .directive('toggleSidebar', [function(){

        return {
            restrict: 'A',
            scope: {
                modelLeft: '=',
                modelRight: '='
            },
            
            link: function(scope, element, attr) {
                element.on('click', function(){

                    if (element.data('target') === 'mainmenu') {
                        if (scope.modelLeft === false) {
                            scope.$apply(function(){
                                scope.modelLeft = true;
                            });
                        }
                        else {
                            scope.$apply(function(){
                                scope.modelLeft = false;
                            });
                        }
                    }
                    
                    if (element.data('target') === 'chat') {
                        if (scope.modelRight === false) {
                            scope.$apply(function(){
                                scope.modelRight = true;
                            });
                        }
                        else {
                            scope.$apply(function(){
                                scope.modelRight = false;
                            });
                        }
                        
                    }
                });
            }
        };

    }])
    /**
     * 
     */
    .directive('toggleSubmenu', ['$rootScope', function($rootScope){

        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var isOpened = false;
                var recentlyOpened = false;
                // jQuery DIRT ....
                element.click(function(){
                    recentlyOpened = true;
                    isOpened = !isOpened;
                    if(isOpened){
                        $rootScope.$broadcast('submenu:open:'+attrs.toggleSubmenu);
                    }
                    element.next().slideToggle(200);
                    element.parent().toggleClass('toggled');
                });
                
                scope.$on('submenu:open:'+attrs.toggleSubmenu, function(){
                    if(isOpened){
                        if(!recentlyOpened){
                            element.next().slideToggle(200);
                            element.parent().toggleClass('toggled');
                            isOpened = !isOpened;
                        }
                        else{
                            recentlyOpened = false;
                        }
                    }
                });
            }
        };
    }])
    /**
     * 
     **/
     .directive('changeLayout', [function(){
    
        return {
            restrict: 'A',
            scope: {
                changeLayout: '='
            },
            
            link: function(scope, element, attr) {
                
                //Default State
                if(scope.changeLayout === '1') {
                    element.prop('checked', true);
                }
                
                //Change State
                element.on('change', function(){
                    if(element.is(':checked')) {
                        localStorage.setItem('ma-layout-status', 1);
                        scope.$apply(function(){
                            scope.changeLayout = '1';
                        });
                    }
                    else {
                        localStorage.setItem('ma-layout-status', 0);
                        scope.$apply(function(){
                            scope.changeLayout = '0';
                        });
                    }
                });
            }
        };
    }]);
    

})(window.angular);